import { Col, Row } from "react-bootstrap";
import type { RebalanceMetrics } from "../../../api/src/rebalances/rebalances.service";
import SummaryPill from "../components/SummaryPill";
import { formatCurrency } from "../lib/numbers";

const RebalanceListSummary = ({
  rebalances,
}: {
  rebalances: RebalanceMetrics[];
}) => (
  <Row className="g-2 mb-4">
    <Col xs={12} sm={6} lg={3}>
      <SummaryPill
        value={rebalances?.length ?? 0}
        label="Households"
        icon="/icons/folded-list.svg"
        size="sm"
      />
    </Col>
    <Col xs={12} sm={6} lg={3}>
      <SummaryPill
        value={formatCurrency(
          rebalances?.reduce(
            (sum, rebalance) => sum + (rebalance.buyTotal ?? 0),
            0,
          ) ?? 0,
        )}
        label="Buy $"
        icon="/icons/buy.svg"
        size="sm"
      />
    </Col>
    <Col xs={12} sm={6} lg={3}>
      <SummaryPill
        value={formatCurrency(
          rebalances?.reduce(
            (sum, rebalance) => sum + (rebalance.sellTotal ?? 0),
            0,
          ) ?? 0,
        )}
        label="Sell $"
        icon="/icons/sell.svg"
        size="sm"
      />
    </Col>
    <Col xs={12} sm={6} lg={3}>
      <SummaryPill
        value={formatCurrency(
          rebalances?.reduce(
            (sum, rebalance) =>
              sum + (rebalance.sellTotal ?? 0) - (rebalance.buyTotal ?? 0),
            0,
          ) ?? 0,
        )}
        label="Net $"
        icon="/icons/cash-register.svg"
        size="sm"
      />
    </Col>
  </Row>
);

export default RebalanceListSummary;
